
export enum TVEyesArchivedStateEnum {
    /** EDITED applies both inside and outside archive contexts — don't assume archive-only. */
    EDITED = 'EDITED',
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED'
}
